import { render, staticRenderFns } from "./SelectionView.vue?vue&type=template&id=07bc3db3&scoped=true&"
import script from "./SelectionView.vue?vue&type=script&lang=js&"
export * from "./SelectionView.vue?vue&type=script&lang=js&"
import style0 from "./SelectionView.vue?vue&type=style&index=0&id=07bc3db3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bc3db3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/matt/dev/georgia/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07bc3db3')) {
      api.createRecord('07bc3db3', component.options)
    } else {
      api.reload('07bc3db3', component.options)
    }
    module.hot.accept("./SelectionView.vue?vue&type=template&id=07bc3db3&scoped=true&", function () {
      api.rerender('07bc3db3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "forms/SelectionView.vue"
export default component.exports